// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3FiE9","buttons":"RemoveExpirationActionButtons_buttons__wX8jr"};